module.exports = __webpack_public_path__ + "img/halloween_600.ac1b7f1.png";